import { render, staticRenderFns } from "./DashboardMortalityCausesGraph.vue?vue&type=template&id=55a51949&"
import script from "./DashboardMortalityCausesGraph.vue?vue&type=script&lang=js&"
export * from "./DashboardMortalityCausesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports